module.exports = __webpack_public_path__ + "static/media/31.29c8b4f5.wav";